export const UserFiltersConfig = {
  User: {
    type: "dropdown",
    expanded: false,
  },

  "L1 Apm Id": {
    type: "dropdown",
    expanded: false,
  },
  "L2 Apm Id": {
    type: "dropdown",
    expanded: false,
  },
  "Site Leader Apm Id": {
    type: "dropdown",
    expanded: false,
  },
};
